
<div class="spinnerContainer">
    <fadv-loader [duration]="2200" #loader></fadv-loader>
  </div>
  
  <fadv-layout>
    <fadv-layout-main>
      <fadv-card>
        <fadv-card-header>
          <div class="card-header-formatting">
            <fadv-box ph="medium" pv="x-small">
              <fadv-grid>
                <fadv-grid-row>
                  <fadv-grid-col>
                    <fadv-typography style="text-align: center" type="heading-small" variant="white">
                      Create Your Account
                    </fadv-typography>
                  </fadv-grid-col>
                </fadv-grid-row>
                <fadv-grid-row>
                  <fadv-grid-col>
                    <fadv-box mt="small" mr="medium" ml="medium">
                      <fadv-typography style="text-align: center;" type="paragraph-medium" variant="white">
                        This will be your system login information
                      </fadv-typography>
                    </fadv-box>
                  </fadv-grid-col>
                </fadv-grid-row>
              </fadv-grid>
            </fadv-box>
          </div>
        </fadv-card-header>
        <form [formGroup]="form" (ngSubmit)="onSubmit()">
          <fadv-card-body id="loginBody">
            <fadv-fieldset>
            <fadv-box p="large">
              <fadv-box mb="large">
                <fadv-fieldset>
                  <fadv-grid-row>
                    <fadv-grid-col id="loginCredentialsCol">
                        <fadv-typography type="heading-small" variant="primary">Login Credentials</fadv-typography>
                    </fadv-grid-col>
                  </fadv-grid-row>
                  <fadv-box>
                  <fadv-input
                  [invalid]="this.emailInvalid"
                  (blur)="showValidation('email')" 
                  formControlName="email" 
                  type="email" label="Company Email Address *">
                    <fadv-icon fadvPrefixIcon library='solid' variant="primary" name='envelope'></fadv-icon>
                  </fadv-input>
                  <span class="error" *ngIf="this.emailInvalid == true">
                    <small *ngIf="this?.form?.get('email').hasError('required')">Email is required</small>
                    <small *ngIf="this?.form?.get('email').hasError('email')">Field must be an email</small>
                  </span>
                  <fadv-input 
                  [invalid]="this.passwordInvalid"
                  (blur)="showValidation('password')"
                  autofocus="autofocus" 
                  formControlName="password" 
                  type="password" label="Password *" 
                  minlength="8">
                    <fadv-icon fadvPrefixIcon library='solid' variant="primary" name='fa-lock'></fadv-icon>
                  </fadv-input>
                  <span class="error" *ngIf="form?.get('password').invalid && form?.get('password').dirty">
                    <small *ngIf="form?.get('password').hasError('required')">Password is required</small>
                  </span>
                  <fadv-password-validator tabindex="1">
                    <fadv-password-rule [valid]="!form?.get('password').hasError('hasLength')"
                      label="Must contain at least 8 characters."></fadv-password-rule>
                    <fadv-password-rule [valid]="!form?.get('password').hasError('hasSpecialCharacters')"
                      label="Must contain at least on of the following symbols. {}+-!@$%^&*()."></fadv-password-rule>
                    <fadv-password-rule [valid]="!form?.get('password').hasError('hasLower')"
                      label="Must contain at least one lowercase letter."></fadv-password-rule>
                    <fadv-password-rule [valid]="!form?.get('password').hasError('hasNumbers')"
                      label="Must contain at least one digit."></fadv-password-rule>
                    <fadv-password-rule style="padding-bottom: 5px;" [valid]="!form.get('password').hasError('hasUpper')"
                      label="Must contain at least one uppercase letter."></fadv-password-rule>
                  </fadv-password-validator>
  
                  <fadv-input 
                  [invalid]="this.confirmPasswordInvalid"
                  (blur)="showValidation('confirmPassword')"
                  type="password" 
                  formControlName="confirmPassword" 
                  label="Confirm Password *">
                  </fadv-input>
                  <span class="error" *ngIf="this.confirmPasswordInvalid">
                    <small *ngIf="form?.get('confirmPassword').hasError('required')">Passwords must match</small>
                    <small *ngIf="f.confirmPassword.errors.mustMatch">Passwords must match</small>
                  </span>
                </fadv-box>
                </fadv-fieldset>
              </fadv-box>
            </fadv-box>
            </fadv-fieldset>
          </fadv-card-body>
        </form>
      </fadv-card>
  
    <div>
      <fadv-card style="padding-top: 5%">
        <form [formGroup]="form" (ngSubmit)="onSubmit()">
        <fadv-card-header>
          <div class="card-header-formatting">
            <fadv-box ph="medium" pv="x-small">
              <fadv-grid>
                <fadv-grid-row>
                  <fadv-grid-col>
                    <fadv-typography style="text-align: center" type="heading-small" variant="white">
                      Company Information
                    </fadv-typography>
                  </fadv-grid-col>
                </fadv-grid-row>
                <fadv-grid-row>
                  <fadv-grid-col>
                    <fadv-box mt="small" mr="medium" ml="medium">
                      <fadv-typography style="text-align: center;" type="paragraph-medium" variant="white">
                        We use this information to verify your business and establish your access to view and manage your background screening results
                      </fadv-typography>
                    </fadv-box>
                  </fadv-grid-col>
                </fadv-grid-row>
              </fadv-grid>
            </fadv-box>
          </div>
        </fadv-card-header>
        <fadv-box p="large">
        <fadv-box mb="large">
          <fadv-grid>
            <fadv-grid-row>
              <fadv-grid-col style="padding-bottom: 8px" alignment="left">
                  <fadv-typography type="heading-small" variant="primary">Basic Information</fadv-typography>
              </fadv-grid-col>
            </fadv-grid-row>
            <fadv-grid-row>
              <div>
                <fadv-tooltip style="position: relative" hoisted="true" hoist="true"
                  content="Enter your exact and full legal business name as registered with the IRS and/or Secretary of State, Examples: SMB R Us, LLC., SMB R Us, Corp.">
                  <fadv-input
                  [invalid]="this.legalCompanyNameInvalid"
                  (blur)="showValidation('legalCompanyName')" 
                  formControlName="legalCompanyName" 
                  label="Legal Company Name *"></fadv-input>
                </fadv-tooltip>
              </div>
              <span class="error" *ngIf="this.legalCompanyNameInvalid == true">
                 <small *ngIf="form?.get('legalCompanyName').hasError('required')">Company Name is required</small>
                 <small *ngIf="form?.get('legalCompanyName').hasError('whitespace') && !form?.get('legalCompanyName').hasError('required')">City cannot be empty</small>
              </span>
           </fadv-grid-row>
          </fadv-grid>
          <fadv-grid>
           <fadv-grid-row>
            <fadv-grid-col [col]="{ lg: 4, xs: 12 }" >
              <fadv-input 
              [invalid]="this.billToZipInvalid"
              (blur)="showValidation('billToZip')" 
              formControlName="billToZip" 
              [maxlength]="5" label="Zipcode *"
              (focusout)="getStateByZip()"></fadv-input>
                <span class="error" *ngIf="this.billToZipInvalid == true">
                  <small *ngIf="form?.get('billToZip').hasError('required')">Zip Code is required</small>
                  <small *ngIf="form?.get('billToZip').hasError('pattern')">Zip Code can only contain numbers</small>
                  <small *ngIf="form?.get('billToZip').hasError('minLength')">Zip Code must be at least 5 numbers</small>
                </span>
            </fadv-grid-col>
              <fadv-grid-col [col]="{ lg: 4, xs: 12 }">
                <fadv-input 
                [invalid]="this.billToCityInvalid"
                (blur)="showValidation('billToCity')" 
                formControlName="billToCity" 
                label="City *"></fadv-input>
                <span class="error" *ngIf="this.billToCityInvalid == true">
                  <small *ngIf="form?.get('billToCity').hasError('required')">City is required</small>
                  <small *ngIf="form?.get('billToCity').hasError('whitespace') && !form?.get('billToCity').hasError('required')">City cannot be empty</small>
                </span>
              </fadv-grid-col>
              <fadv-grid-col [col]="{ lg: 4, xs: 12 }">
                <fadv-input 
                [invalid]="this.billToStateInvalid"
                (blur)="showValidation('billToState')"
                oninput="this.value = this.value.toUpperCase()" 
                maxlength="2" minlength="2"
                autocapitalize="on"
                formControlName="billToState" 
                label="State *" id="billToState" 
                value="{{selectedState.name}}">
                  {{ selectedState.name }}
                </fadv-input>
                <span class="error" *ngIf="this.billToStateInvalid == true">
                  <small *ngIf="form?.get('billToState').hasError('required')">State is required</small>
                  <small *ngIf="form?.get('billToState').hasError('pattern')">State must be two letters</small>
                  <small *ngIf="form?.get('billToState').hasError('whitespace') && !form?.get('billToState').hasError('required')">State cannot be empty</small>
                </span>
              </fadv-grid-col>
           </fadv-grid-row>
          </fadv-grid>
          <fadv-grid>
              <fadv-grid-row>
                <fadv-grid-col [col]="{ lg: 6, xs: 12 }" alignment="left">
                  <fadv-input 
                  [invalid]="this.billToAddressInvalid"
                  (blur)="showValidation('billToAddress')"
                   formControlName="billToAddress" 
                   label="Street Address *" 
                   size="small"></fadv-input>
                  <span class="error" *ngIf="this.billToAddressInvalid == true">
                    <small *ngIf="form?.get('billToAddress').hasError('required')">Street Address is required</small>
                    <small *ngIf="form?.get('billToAddress').hasError('whitespace') && !form?.get('billToAddress').hasError('required')">Street Address cannot be empty</small>
                  </span>
                 </fadv-grid-col>
                <fadv-grid-col [col]="{ lg: 6, xs: 12 }">
                  <div>
                    <fadv-tooltip style="position: relative" hoisted="true" hoist="true"
                      content="Providing your mobile number may expedite the business verification process.">
                      <fadv-input 
                      [invalid]="this.mobilephonenumberInvalid"
                      (blur)="showValidation('mobilephonenumber')"
                      formControlName="mobilephonenumber" label="Mobile Phone Number" size="small"
                      [maxlength]="10" [minlength]="10"
                      type="tel">
                        <fadv-icon fadvSuffixIcon library='solid' name='fa-question'></fadv-icon>
                      </fadv-input>
                    </fadv-tooltip>
                  </div>
                  <span class="error" *ngIf="mobilephonenumberInvalid">
                    <small *ngIf="form?.get('mobilephonenumber').hasError('pattern')">Phone Number can only contain numbers</small>
                    <small *ngIf="form?.get('mobilephonenumber').hasError('minlength') && !form?.get('mobilephonenumber').hasError('pattern')">Phone Number must be 10 digits</small>
                  </span>
                </fadv-grid-col>
              </fadv-grid-row>
            </fadv-grid>
        </fadv-box>
      </fadv-box>
      <fadv-box p="large">
        <fadv-box mb="large">
            <fadv-grid-row>
              <fadv-grid-col style="padding-bottom: 8px" alignment="left">
                  <fadv-typography type="heading-small" variant="primary">Additional Information</fadv-typography>
              </fadv-grid-col>
            </fadv-grid-row>
            <fadv-grid>
              <fadv-grid-row>
                <fadv-grid-col [col]="{ lg: 6, xs: 12 }" alignment="left">
                  <fadv-select formControlName="ownershiptype" hoist="true" scrollable="true" label="Ownership Type *">
                    <fadv-menu-item *ngFor="let type of ownershipTypes | keyvalue" value="{{type.value}}">
                      {{type.value}}</fadv-menu-item>
                  </fadv-select>
                </fadv-grid-col>
                <fadv-grid-col [col]="{ lg: 6, xs: 12 }" alignment="right">
                  <fadv-select formControlName="stateofincorporation" label="State of Incorporation *" hoist="true" scrollable="true" value="">
                      <fadv-menu-item *ngFor="let state of states" value="{{state.code}}">{{ state.name }}</fadv-menu-item>
                  </fadv-select>
                </fadv-grid-col>
              </fadv-grid-row>
  
              <fadv-input [col]="12" formControlName="taxid_ein" label="Company Tax ID/Employer Identification Number"></fadv-input>
              <fadv-select formControlName="clientagreementpermissiblepurpose" hoist="true" scrollable="true" label="Permissible Purpose *">
                <fadv-menu-item *ngFor="let type of permissiblePurpose | keyvalue" value="{{type.value}}">
                  {{type.value}}</fadv-menu-item>
              </fadv-select>
              <span class="error" *ngIf="form?.get('clientagreementpermissiblepurpose').invalid && form?.get('clientagreementpermissiblepurpose').dirty">
                <small>Nature of Business is Required</small>
              </span>
              <fadv-grid-row>
                <fadv-grid-col [col]="{ lg: 6, xs: 12 }" >
                  <fadv-checkbox (checkedChange)="eSignAuth($event)"  variant="standard" formControlName="authorization">I agree to
                    <fadv-button  fadvCheckboxLink (click)="showEsignAuth()" variant='text' style="color:#3E82C8;" name="partner-esig-button">electronic signature authorization.</fadv-button>
                  </fadv-checkbox>
                </fadv-grid-col>
              </fadv-grid-row>
              <fadv-grid-row>
                <fadv-grid-col [col]="12">
                  <fadv-checkbox style="padding-top: 15px;" [disabled]="isDisabled" #agreementBox
                  (checkedChange)="clientAgreement($event)" [checked]="isSigned" variant="standard" formControlName="agreement">Sign
                    <fadv-button fadvCheckboxLink [disabled]="isDisabled" (click)="getClientAgreement()" variant='text' style="color:#3E82C8;" name="partner-agree-button">Agreement for Services</fadv-button>
                  </fadv-checkbox>
                </fadv-grid-col>
              </fadv-grid-row>
            </fadv-grid>
          </fadv-box>
        </fadv-box>
        <fadv-grid>
          <fadv-grid-row>
            <fadv-grid-col>
              <fadv-box>
              <fadv-typography type="paragraph-small">
                I understand that, by law, First Advantage cannot return background check results until my <a href="https://fadv.com/smallbusiness/support/" target="_new">business verification</a> is complete.
              </fadv-typography>
              </fadv-box>
            </fadv-grid-col>
          </fadv-grid-row>
          <fadv-grid-row [ngStyle]="{'padding-bottom': bottomRowPadding}">
            <fadv-grid-col [col]="{lg: 6, xs: 12, sm: 12, md: 12}" alignment="center">
              <div style="display: inline-block;">
                <fadv-box [p]="{xs: 'medium', sm: 'medium', md: 'medium', lg: 'large'}">
                  <fadv-button size="large" class="accountFormButton"
                    (click)="onCancel()" name="partner-account-back-button">Back</fadv-button>
                </fadv-box>
              </div>
            </fadv-grid-col>
            <fadv-grid-col [col]="{lg: 6, xs: 12, sm: 12, md: 12}" alignment="center">
              <div style="display: inline-block;">
                <fadv-box [p]="{xs: 'medium', sm: 'medium', md: 'large', lg: 'large'}">
                  <fadv-tooltip content="{{ invalidTooltip }} {{ invalidTooltipList }}" [disabled]="this.form.valid">
                  <div class="tooltipContainer">
                    <fadv-button (mouseenter)="updateInvalidTooltip()" (mouseleave)="resetInvalidTooltip()" [loading]="loading" [active]="loading" [disabled]="loading" [disabled]="!this.form.valid" 
                    size="large" variant='primary' (click)="onSubmit()" class="accountFormButton"
                      type="button" name="partner-done-button">Done</fadv-button>
                  </div>
                  </fadv-tooltip>
                </fadv-box>
              </div>
            </fadv-grid-col>
          </fadv-grid-row>
        </fadv-grid>
        </form>
      </fadv-card>
  
      <fadv-modal #agreementsignmodal size="large"   >
  
        <fadv-modal-header>Please Sign</fadv-modal-header>
  
        <fadv-modal-body>
          <div style="text-align: center;">
            <fadv-signature
          #signbox
            [drawSignature]="true"
            useDefaultDisclaimer="true"
            [drawOnly]="true"
  
          ></fadv-signature>
         </div>
         <fadv-box [mt]="{ xxl: 'xx-large', xl: 'xx-large', lg: 'xx-large', md: 'xx-large', sm: 'large', xs: 'large' }">
          <fadv-grid>
            <fadv-grid-row>
              <fadv-grid-col [col]="{ xxl: 6, xl: 6, lg: 6, md: 6, sm: 12, xs: 12 }" [alignment]="{ xxl: 'right', xl: 'right', lg: 'right', md: 'right', sm: 'center', xs: 'center' }" >
                  <fadv-button style="width:200px;height:44px;" (click)="cancelSign()" name="partner-account-cancel-button" fadvModalButton>Cancel</fadv-button>
              </fadv-grid-col>
              <fadv-grid-col [col]="{ xxl: 6, xl: 6, lg: 6, md: 6, sm: 12, xs: 12 }" [alignment]="{ xxl: 'left', xl: 'left', lg: 'left', md: 'left', sm: 'center', xs: 'center' }">
                <fadv-button style="width:200px;height:44px;" (click)="sign()" fadvModalButton variant="primary" name="partner-account-sign-button">Sign</fadv-button>
              </fadv-grid-col>
            </fadv-grid-row>
          </fadv-grid>
        </fadv-box>
        </fadv-modal-body>
  
      </fadv-modal>
      <fadv-modal #agreementmodal size="large">
  
        <fadv-modal-header>Client Agreement</fadv-modal-header>
  
        <fadv-modal-body>
          <div data-is-focusable="true" data-is-scrollable="true"
            style="margin: 0px; width:100%;  max-width: 100%;
            overflow-x: hidden; border: 0px; font: inherit; vertical-align: baseline;
            color: inherit;  position: relative; height: 400px; -webkit-box-flex: 1; flex: 1 1 auto; outline: 0px;"
            tabindex="0">
            <span [innerHTML]="clientLegalFormHTML"></span>
  
          </div>
        </fadv-modal-body>
        <fadv-button fadvModalButton (click)="closeAgreement()" variant="neutral" name="partner-account-close-button">Close</fadv-button>
  
      </fadv-modal>
      <fadv-modal #esignmodal size="large">
  
        <fadv-modal-header>E-Sign Authorization</fadv-modal-header>
  
        <fadv-modal-body>
          <div data-is-focusable="true" data-is-scrollable="true"
            style="margin: 0px; width:100%;  max-width: 100%;
            overflow-x: hidden; border: 0px; font: inherit; vertical-align: baseline; 
            color: inherit;  position: relative; height: 400px; -webkit-box-flex: 1; flex: 1 1 auto; outline: 0px;"
            tabindex="0">
            <span [innerHTML]="eSignLegalFormHTML"></span>
  
          </div>
  
        </fadv-modal-body>
        <fadv-button fadvModalButton (click)="closeESign()" variant="neutral" name="partner-account-close-esign-button">Close</fadv-button>
      </fadv-modal>
  
  
